/* ==========================================================================
   SASKSTORE — theme.js
   Galerie, variantes, quantité + pack, formulaire de commande WhatsApp,
   menu mobile, barre collante.
   ========================================================================== */
(function () {
  'use strict';

  var SASK = window.SASK || {};
  var money = function (n) {
    var s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s + ' F';
  };

  /* ------------------------------------------------------------------ menu */
  function initMenu() {
    var burger = document.querySelector('.js-burger');
    var menu = document.querySelector('.js-menu');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () { menu.classList.add('on'); });
    menu.addEventListener('click', function (e) {
      if (e.target === menu || e.target.closest('.js-menu-close')) menu.classList.remove('on');
    });
  }

  /* --------------------------------------------------------------- galerie */
  function initGallery() {
    var main = document.querySelector('.js-main-image');
    var thumbs = document.querySelectorAll('.js-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var src = t.getAttribute('data-src');
        var srcset = t.getAttribute('data-srcset');
        if (src) main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset);
      });
    });
  }

  /* ----------------------------------------- cartes / pastilles d'options */
  function initOptionCards() {
    var cards = document.querySelectorAll('.js-opt');
    if (!cards.length) return;
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var i = c.getAttribute('data-opt');
        var group = document.querySelector('.js-opt-group[data-index="' + i + '"]');
        if (group) {
          group.querySelectorAll('.js-opt').forEach(function (x) { x.classList.remove('on'); });
        }
        c.classList.add('on');
        var sel = document.querySelector('.js-option[data-index="' + i + '"]');
        if (sel) {
          sel.value = c.getAttribute('data-value');
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var lab = document.querySelector('.js-opt-label-' + i);
        if (lab) lab.textContent = c.getAttribute('data-value');
      });
    });
  }

  /* ------------------------------------------------------------ variantes */
  function initVariants() {
    var root = document.querySelector('[data-variants]');
    if (!root) return;

    var variants = [];
    try { variants = JSON.parse(root.getAttribute('data-variants')) || []; } catch (e) { variants = []; }

    var form = document.getElementById('form-produit');
    var priceEl = document.querySelector('.js-price');
    var compareEl = document.querySelector('.js-compare');
    var stickyPrice = document.querySelector('.js-sticky-price');
    var addBtn = document.querySelector('.js-add');
    var stockEl = document.querySelector('.js-stock');
    var selectors = root.querySelectorAll('.js-option');

    function currentVariant() {
      var opts = [];
      selectors.forEach(function (s) { opts.push(s.value); });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options && v.options.length === opts.length && v.options.every(function (o, k) { return o === opts[k]; })) {
          return v;
        }
      }
      return variants[0] || null;
    }

    function render() {
      var v = currentVariant();
      if (!v) return;
      var hidden = form ? form.querySelector('input[name="id"]') : null;
      if (hidden) hidden.value = v.id;

      if (priceEl) priceEl.textContent = money(v.price / 100);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price / 100);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price / 100);

      var available = v.available !== false;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? (addBtn.getAttribute('data-label') || 'Commander') : 'Épuisé';
      }
      if (stockEl) {
        stockEl.classList.toggle('stock--out', !available);
        stockEl.innerHTML = available
          ? '<i></i> En stock — livraison 24h à N\'Djamena'
          : '<i></i> Rupture temporaire — écrivez-nous sur WhatsApp';
      }
      syncRecap();
      var u = root.querySelector('.js-unit-price');
      if (u) u.textContent = money(v.price / 100);
      /* aligne les cartes sur la variante réellement sélectionnée */
      if (v.options && v.options.length) {
        v.options.forEach(function (val, i) {
          document.querySelectorAll('.js-opt-group[data-index="' + i + '"] .js-opt').forEach(function (c) {
            c.classList.toggle('on', c.getAttribute('data-value') === val);
          });
          var lab = document.querySelector('.js-opt-label-' + i);
          if (lab) lab.textContent = val;
        });
      }

      var waBtn = document.querySelector('.js-wa-buy');
      if (waBtn && v.title) {
        var base = waBtn.getAttribute('data-base') || '';
        waBtn.setAttribute('href', 'https://wa.me/' + (SASK.whatsapp || '') +
          '?text=' + encodeURIComponent(base + ' — ' + v.title + ' (' + money(v.price / 100) + ')'));
      }
    }

    selectors.forEach(function (s) { s.addEventListener('change', render); });

    /* quantité + paliers (1 / 2 / 3 paires) */
    var qty = 1;
    var qtyEl = document.querySelector('.js-qty-value');

    function tiers(unit) {
      var t = {};
      t[1] = unit;
      var pq = parseInt(SASK.packQty || 2, 10);
      var pp = parseFloat(SASK.packPrice || 0);
      var p3 = parseFloat(SASK.pack3Price || 0);
      if (pq > 0 && pp > 0) t[pq] = pp;
      if (p3 > 0) t[3] = p3;
      return t;
    }
    /* meilleur prix possible pour n paires (programmation dynamique) */
    function bestPrice(unit, n) {
      var t = tiers(unit), dp = [0];
      for (var i = 1; i <= n; i++) {
        dp[i] = Infinity;
        for (var k in t) {
          k = +k;
          if (k <= i && t[k] > 0) dp[i] = Math.min(dp[i], dp[i - k] + t[k]);
        }
      }
      return dp[n];
    }

    function syncRecap() {
      if (qtyEl) qtyEl.textContent = qty;
      var v = currentVariant();
      var unit = v ? v.price / 100 : 0;
      var total = bestPrice(unit, qty) || unit * qty;
      /* titane 10331294433526 : remise fixe -packOff2 dès 2, -packOff3 dès 3 (remises automatiques Shopify) */
      if (SASK.packOff2 || SASK.packOff3) {
        var off = qty >= 3 ? (+SASK.packOff3 || 0) : (qty >= 2 ? (+SASK.packOff2 || 0) : 0);
        total = Math.max(0, unit * qty - off);
      }
      var saved = Math.max(0, unit * qty - total);
      var hint = document.querySelector('.js-qty-hint');
      if (hint) {
        if (saved > 0) {
          hint.innerHTML = '<b style="color:#0d6b3e">Offre ' + qty + ' paires : ' + money(total) +
            ' <span style="color:#6b7382;font-weight:600">(économie ' + money(saved) + ')</span></b>';
        } else {
          hint.textContent = qty + (qty > 1 ? ' paires · ' : ' paire · ') + money(total);
        }
      }
      var r1 = document.querySelector('.js-recap-line');
      var r2 = document.querySelector('.js-recap-total');
      var r3 = document.querySelector('.js-recap-ship');
      if (r1) r1.textContent = qty + ' × ' + money(unit);
      if (r2) r2.textContent = money(total);
      if (r3) r3.textContent = 'Gratuite';
      var hiddenQty = form ? form.querySelector('input[name="quantity"]') : null;
      if (hiddenQty) hiddenQty.value = qty;
      return { unit: unit, total: total, saved: saved };
    }

    var plus = document.querySelector('.js-plus');
    var minus = document.querySelector('.js-minus');
    if (plus) plus.addEventListener('click', function () { if (qty < 10) { qty++; syncRecap(); } });
    if (minus) minus.addEventListener('click', function () { if (qty > 1) { qty--; syncRecap(); } });

    render();

    /* ------------------------------------------------- formulaire commande */
    var codBtn = document.querySelector('.js-cod-send');
    if (codBtn) {
      codBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var get = function (sel) { var el = document.querySelector(sel); return el ? el.value.trim() : ''; };
        var fields = [
          { id: '.js-f-nom', ok: function (v) { return v.length >= 3; } },
          { id: '.js-f-tel', ok: function (v) { return v.replace(/\D/g, '').length >= 8; } },
          { id: '.js-f-quartier', ok: function (v) { return v.length > 0; } },
          { id: '.js-f-repere', ok: function (v) { return v.length >= 2; } }
        ];
        var valid = true, firstBad = null;
        fields.forEach(function (f) {
          var el = document.querySelector(f.id);
          if (!el) return;
          var wrap = el.closest('.field');
          var good = f.ok(el.value.trim());
          if (wrap) wrap.classList.toggle('bad', !good);
          if (!good) { valid = false; if (!firstBad) firstBad = el; }
        });
        if (!valid) { if (firstBad) firstBad.focus(); return; }

        var v = currentVariant();
        var t = syncRecap() || { unit: v ? v.price / 100 : 0, total: 0 };
        var productEl = document.querySelector('.js-product-title');
        var title = productEl ? productEl.textContent.trim() : 'ma commande';
        var msg = 'BONJOUR SASK 👋 Je veux commander :\n\n'
          + '• Modèle : ' + title + (v && v.title && v.title !== 'Default Title' ? ' — ' + v.title : '') + '\n'
          + '• Quantité : ' + qty + '\n'
          + '• Prix : ' + money(t.total) + (t.saved > 0 ? ' (offre, économie ' + money(t.saved) + ')' : '') + '\n'
          + '• Nom : ' + get('.js-f-nom') + '\n'
          + '• Téléphone : ' + get('.js-f-tel') + '\n'
          + '• Quartier : ' + get('.js-f-quartier') + '\n'
          + '• Repère : ' + get('.js-f-repere') + '\n'
          + '• Créneau : ' + (get('.js-f-creneau') || 'demain matin') + '\n\n'
          + 'Paiement à la livraison ✅';
        window.open('https://wa.me/' + (SASK.whatsapp || '') + '?text=' + encodeURIComponent(msg), '_blank');
      });
    }
  }

  /* ------------------------------------------------------- ajout au panier */
  function initCart() {
    var form = document.getElementById('form-produit');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.js-add');
      if (btn) {
        var old = btn.textContent;
        btn.disabled = true; btn.textContent = 'Ajout…';
        /* l'app de commande (COD) peut ouvrir une fenêtre au lieu de naviguer :
           on rend le bouton pour ne jamais bloquer le client */
        setTimeout(function () {
          btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || old;
        }, 2500);
      }
    });
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var btn = document.querySelector('.js-add');
    if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || 'Commander'; }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initOptionCards();
    initGallery();
    initVariants();
    initCart();
  });
})();
